import React from "react";
import { Button, Row, Col, Space } from "antd";
import { Form as FinalForm, Field } from "react-final-form";
import FormGroup from "components/form/formGroup";

const ModalForm = ({ onSubmit, note }) => {
  const onSubmitForm = (values) => {
    onSubmit({ ...values, createdAt: values.createdAt.toISOString() });
  };

  const initialValues = note
    ? {
        ...note,
        createdAt: new Date(note.createdAt),
      }
    : {
        createdAt: new Date(),
      };

  return (
    <FinalForm
      onSubmit={onSubmitForm}
      initialValues={initialValues}
      render={({ handleSubmit, submitting }) => (
        <Space direction="vertical">
          <Field
            name="content"
            inputStyle={{ minHeight: 300 }}
            component={FormGroup}
            type="markdown"
            className="markdown"
          ></Field>

          <Row gutter={24}>
            <Col span={12}>
              <Field
                type="checkbox"
                name="isCommon"
                children="Common"
                component={FormGroup}
              />
            </Col>

            <Col span={12}>
              <Field type="date" name="createdAt" component={FormGroup} />
            </Col>
          </Row>

          <Button
            type="primary"
            onClick={handleSubmit}
            loading={submitting}
            style={{ position: "relative", top: "-10px" }}
          >
            {submitting ? "Please wait..." : "Save Note"}
          </Button>
        </Space>
      )}
    />
  );
};

export default ModalForm;
